import { render, staticRenderFns } from "./Shipping.vue?vue&type=template&id=cbf84276&scoped=true&"
import script from "./Shipping.vue?vue&type=script&lang=js&"
export * from "./Shipping.vue?vue&type=script&lang=js&"
import style0 from "./Shipping.vue?vue&type=style&index=0&id=cbf84276&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf84276",
  null
  
)

export default component.exports